import { IntercomIntegration } from './intercom';
import { MixpanelIntegration } from './mixpanel';
import { PushPermissionIntegration } from './push-permission';

/**
 * Mount-once aggregator for the auth-boot SDK integrations.
 *
 * Each child renders nothing; they hook `useAuthStore` and run side-effects
 * (Intercom boot, Mixpanel identify + route-change tracking, browser
 * Notification permission ask) when the user becomes available.
 *
 * Order doesn't matter — each is independent. Mounted in `main.tsx`
 * under the QueryClientProvider + Router so all three have access to
 * route + auth state.
 *
 * Note: `<MixpanelIntegration />` uses `react-router-dom` hooks so this
 * MUST live inside the router's tree.
 */
export function AppIntegrations() {
  return (
    <>
      <IntercomIntegration />
      <MixpanelIntegration />
      <PushPermissionIntegration />
    </>
  );
}
